/** Approval is independent of whether the attendance is Planned or Modified. */
import { approvalLabel, approvalTone, approvalTooltip, TaskApprovalStatus, VisitBrowseRow } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

type ApprovalStatus = NonNullable<VisitBrowseRow['approvalStatus']>;

/** "Partly approved · 3 of 5" when the task-row counts are read; the plain standing otherwise. */
export function visitApprovalLabel(row: VisitBrowseRow, status: ApprovalStatus): string {

  const summary = row.approvalSummary;
  if (status !== TaskApprovalStatus.PartlyApproved || !summary?.total) return approvalLabel(status);

  return `${approvalLabel(status)} · ${summary.approved} of ${summary.total}`;
}

/** Once a Job exists the Job is the Visit's record, so an approval validity pill would only be noise. */
export const visitApprovalTag = defineConditionalTag<VisitBrowseRow>(row => {

  const status = row?.approvalStatus;
  if (row?.job?._id || !status || !approvalTone(status)) return null;
  return visitApprovalPill(row, status);
});

/**
 * The quickview names only the standings someone should notice; Approved / Not approved on every Visit was
 * noise. Partly approved is named because its Job will leave the unapproved tasks out.
 */
const ATTENTION = new Set<ApprovalStatus>([TaskApprovalStatus.AutoApproved, TaskApprovalStatus.NeedsReview, TaskApprovalStatus.PartlyApproved]);

export const visitApprovalAttentionTag = defineConditionalTag<VisitBrowseRow>(row => {

  const status = row?.approvalStatus;
  if (row?.job?._id || !status || !ATTENTION.has(status)) return null;
  return visitApprovalPill(row, status);
});

function visitApprovalPill(row: VisitBrowseRow, status: ApprovalStatus) {

  const tooltip = approvalTooltip(status);
  return { label: visitApprovalLabel(row, status), tone: approvalTone(status), ...(tooltip ? { tooltip } : {}) };
}
